import { useEffect, useRef } from 'react'
import { getConsentFromDocument } from '#app/utils/consent.ts'

export function useAnalyticsIdentify(
	user: { id: string; name: string | null; email: string } | null | undefined,
) {
	const identifiedUserIdRef = useRef<string | null>(null)

	useEffect(() => {
		if (getConsentFromDocument() !== 'granted' || !ENV.POSTHOG_API_KEY) return

		if (user && identifiedUserIdRef.current !== user.id) {
			identifiedUserIdRef.current = user.id
			void import('#app/utils/analytics.client.tsx').then((m) =>
				m.identifyUser(user.id, {
					name: user.name,
					email: user.email,
				}),
			)
		} else if (!user && identifiedUserIdRef.current) {
			identifiedUserIdRef.current = null
			void import('#app/utils/analytics.client.tsx').then((m) => m.resetUser())
		}
	}, [user])
}
